import { render, staticRenderFns } from "./DesignSettingBar.vue?vue&type=template&id=40160073&scoped=true&"
import script from "./DesignSettingBar.vue?vue&type=script&lang=ts&"
export * from "./DesignSettingBar.vue?vue&type=script&lang=ts&"
import style0 from "./DesignSettingBar.vue?vue&type=style&index=0&id=40160073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40160073",
  null
  
)

export default component.exports